<template>
  <!-- 首屏 banner 区域 -->
  <section class="banner-section">
    <div class="container home_swiper">
      <div class="row">
        <div class="col-md-6">
          <div class="banner-content">
            <div class="banner-info">
              <h1 class="banner-title">
                <!-- <div><img src="@/assets/uupay/images/uu.png"></div> 
                <div class="banner-title-uu">秒過數</div> -->
                <slot name="title"></slot>
              </h1>
              <h1 class="banner-title">
                <!-- 輕鬆對接收款 -->
                <slot name="subtitle"></slot>
              </h1>
              <p class="banner-subtitle">
                <!-- 簡單 安全 迅速 / 0機價全面提升業務 -->
                <slot name="info"></slot>
              </p>
              <button class="banner-btn download" @click="toDownload">立即下載</button>
              <button class="banner-btn contact-us" @click="contactUs">聯絡我們</button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="banner-content">
            <img :src="getImage(bannerImg)" alt="banner-img" class="img-fluid banner-img">
          </div>
        </div>
      </div>
    </div>
    
    <custom-dialog :visible.sync="download" width="500px"/>
  </section>
</template>
<script>
import CustomDialog from "@/components/CustomDialog";

export default {
  name: 'PriceBanner',
  components: {
    CustomDialog
  },
  props: {
    bannerImg: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      download: false
    }
  },
  methods: {
    getImage(name) {
      return require(`@/assets/uupay/images/${name}.png`)
    },
    contactUs() {
      console.log('聯繫我們');
    },
    toDownload() {
      this.download = true
    },
  }
}
</script>
<style scoped>
.banner-section {
  background: #fff;
  
  width: 100%;
  height: 660px;
  position: relative;
  
}
.banner-info {
  /*width: 560px;*/
}
.banner-bg {
  height: 827px;
  background-image: url('/static/home_line.svg');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  position: absolute;
  width: 60vw;
  right: 0;
}

.banner-content {
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.banner-img {
  height: 420px;
  /*padding: 25px;*/
 
}

.banner-console {
  position: absolute;
  right: 0;
  height: 700px;
}

.banner-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #7b2cbf;
  display: flex;
  font-size: 70px;
  line-height: 80px;
  color: #21042e;
}
.banner-title .home1-img {
  width: 216px;
  height: 70px;
  margin-right: 10px;
}
.banner-title .home1-img img {
  width: 104px;
  height: 64px;
}
.banner-title .home2-img {
  width: 70px;
  height: 70px;
  margin-right: 10px;
}

.banner-title-uu {
  color: #9A307A;
}

.banner-subtitle {
  color: #bc68a4;
  margin: 40px 0 60px 0;
}
.banner-btn {
  width: 160px;
  height: 60px;
  border-radius: 50px;
  font-size: 18px;
  line-height: 24px;
  cursor: pointer;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
.banner-btn:hover, .banner-btn:focus {
  text-decoration: none;
  outline: none;
}
.download {
  color: #fff;
  border: none;
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
  margin-right: 1rem;
  border: none;
}
.contact-us {
  color: #9A307A;
  background: inherit;
  border: 2px solid;
  position: relative;
  background-clip: padding-box; /*important*/
}
.contact-us::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: -1;
  margin: -2px;
  border-radius: inherit; /*important*/
  background: linear-gradient(to bottom, #894395, #840c60);
}
</style>


// WEBPACK FOOTER //
// src/components/PriceBanner.vue